import { fromIso } from '../../format/dates'

/** Pas vanaf zoveel eigen posts iets zeggen over de beste dag en tijd; daaronder is het toeval. */
export const BEST_SLOT_MIN_POSTS = 20

type Post = { date: string; time: string; reach: number }

/**
 * Het beste moment om te posten, op basis van de eigen posts: het dagdeel (weekdag + uur) met
 * het hoogste gemiddelde bereik, met minstens twee posts in dat vak. `null` bij te weinig posts.
 */
export function bestSlot(posts: readonly Post[]): { weekday: number; hour: number } | null {
  if (posts.length < BEST_SLOT_MIN_POSTS) return null
  const slots = new Map<string, { weekday: number; hour: number; reach: number; n: number }>()
  posts.forEach((p) => {
    const weekday = fromIso(p.date).getDay()
    const hour = Number(p.time.slice(0, 2))
    if (!Number.isFinite(hour)) return
    const key = `${weekday}-${hour}`
    const s = slots.get(key) ?? { weekday, hour, reach: 0, n: 0 }
    slots.set(key, { ...s, reach: s.reach + p.reach, n: s.n + 1 })
  })
  const best = [...slots.values()].filter((s) => s.n >= 2).sort((a, b) => b.reach / b.n - a.reach / a.n)[0]
  return best ? { weekday: best.weekday, hour: best.hour } : null
}
